import { render } from "./ExclusiveBadge.vue?vue&type=template&id=09b51544&scoped=true"
import script from "./ExclusiveBadge.vue?vue&type=script&lang=js"
export * from "./ExclusiveBadge.vue?vue&type=script&lang=js"

import "./ExclusiveBadge.vue?vue&type=style&index=0&id=09b51544&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b51544"]])

export default __exports__